// Per-currency locale so each currency renders in its own convention:
// EUR keeps the existing European form (1.234,56 €), while GBP/USD use the
// English dot-decimal form (£1,234.56 / $1,234.56).
const LOCALE_BY_CODE = {
	EUR: 'el',
	GBP: 'en-GB',
	USD: 'en-US'
};

/**
 * Formats an already-normalized (major-unit) amount using the currency object
 * returned alongside every money field by the API: { code, symbol, decimals }.
 *
 * The `currency` argument is treated as nullable (one release cycle of defensive
 * handling) and falls back to EUR / €. Callers keep normalizing the raw integer
 * amount with AmountFormatHelper.formatAmount before passing it in.
 */
export const UseCurrencyDecorator = () => {
	return (amount, currency) => {
		const code = currency?.code ?? 'EUR';
		const decimals = currency?.decimals ?? 2;
		const locale = LOCALE_BY_CODE[code] ?? 'en-GB';
		const value = parseFloat(amount) || 0;

		try {
			// style:'currency' handles symbol placement + separators per locale.
			return new Intl.NumberFormat(locale, {
				style: 'currency',
				currency: code,
				minimumFractionDigits: decimals,
				maximumFractionDigits: decimals
			}).format(value);
		} catch (e) {
			// Unknown ISO code: fall back to the symbol provided by the response.
			const symbol = currency?.symbol ?? '€';
			return (
				value.toLocaleString(locale, {
					minimumFractionDigits: decimals,
					maximumFractionDigits: decimals
				}) +
				' ' +
				symbol
			);
		}
	};
};
